import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../../../environments/environment";

@Injectable({ providedIn: "root" })
export class VigilantVersionService {
  constructor(private http: HttpClient) {}

  url = environment.vigilantApiUrl;

  /**
   * Retrieves the API version from the server.
   *
   * @returns {Observable<string>} An Observable emitting the API version as a string.
   */
  getVersion(): Observable<string> {
    return this.http.get<string>(`${this.url}/api/Version`);
  }
}
